<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="30px">

    <!-- #region Upload,Export Export All buttons -->
    <div fxLayout="column">
      <div fxLayout="column" fxLayoutAlign="flex-start start">
        <div fxLayout="column" *ngIf="!currentUserIsPartner()">
          <mat-button-toggle-group>
            <mat-button-toggle #allButton checked
                               class="mat-b-toggle-thin"
                               (click)="filterCancellationStatus(0)"
                               value="0">
              <label class="label-for-mat-toggle-button">All</label></mat-button-toggle>
            <mat-button-toggle #pendingButton class="mat-b-toggle-thin" (click)="filterCancellationStatus(1)"><label
              class="label-for-mat-toggle-button">Pending</label></mat-button-toggle>
            <mat-button-toggle class="mat-b-toggle-thin" (click)="filterCancellationStatus(2)"><label
              class="label-for-mat-toggle-button">Done</label></mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
    <div fxFlex></div>
    <!-- #endregion Upload,Export Export All buttons -->

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">



<!--

        <mat-form-field>
          <mat-label>Cancellation status</mat-label>
          <mat-select [formControl]="orderCancellationStatusSelect" (selectionChange)="onOrderCancellationStatusChange()">
            <mat-option *ngFor="let cs of orderCancellationStatus | enumToArray"
                        [value]="cs.index">
              {{cs.name | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
-->

        <div fxLayout="column" fxLayoutAlign="flex-end center">
          <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
            <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
              [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
            <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
              [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
            <mat-form-field class="date-filter-field">
              <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
                <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">{{dateFilter.header}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="search-field">
              <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                [(ngModel)]="table.filters.str">
            </mat-form-field>
            <button #searchButton mat-icon-button (click)="onSearch()"
              [disabled]="startDateFilter.invalid || endDateFilter.invalid">
              <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button (click)="table.clearFilter()">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>

        <!-- #endregion star-end data, date filters, search -->

      </div>
    </div>
  </div>
  <app-mat-table-generator #table
    tableName="cancellationOrdersTable"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="false"
    [deleteEnabled]="false"
    [multiselectEnabled]="false"
    [viewLink]="getViewLink"
    [editLink]="getEditLink"
    (clearingFilters)="checkAllButton()"
    [dialogRemoveText]="dialogRemoveText">
  </app-mat-table-generator>
</mat-card>
